import { Component, OnInit } from '@angular/core';
import {FormBuilder, Validators} from "@angular/forms";
import {Router} from "@angular/router";
import {NotifierService} from "angular-notifier";
import {UserService} from "../../../service/user.service";
import {BsModalService, BsModalRef} from "ngx-bootstrap";

@Component({
  selector: 'app-booking',
  templateUrl: './booking.component.html',
  styleUrls: ['./booking.component.scss']
})
export class BookingComponent implements OnInit {
  bookings:any [];
  listOfData:any [];
  modalRef: BsModalRef;
  requestId: any;
  page: any;
  totalRec: any;
  currentPage: any;
  searchForm: any;
  resonForm: any;
  constructor(private formBuilder: FormBuilder, private route: Router, private notifier: NotifierService,
              private userService: UserService, private modalService: BsModalService,) {
    this.searchForm = this.formBuilder.group({
      client: ["",],
      email: ["",],
      mobile: ["",],

    });
    this.resonForm = this.formBuilder.group({
      reson: ["", [Validators.required]],

    });
  }

  ngOnInit() {
    this.getAll(1);

  }

  createModal() {

  }

  getAll(pageIndex){
    let req={}
    let size = 10;
    let page = pageIndex - 1;
    this.userService.bookinggetAll(size,page,req).subscribe(
      res=>{
        if (res.responseCode === 200) {
          this.bookings =res['data']['content'];
          this.page = res['data']['number'];
          this.totalRec = res['data']['totalElements'];
        } else {
          this.notifier.notify('danger', res.responseDesc);
        }
      }
    )
  }

  save() {
    this.userService.bookingSave().subscribe(
      res=>{
        if (res.responseCode === 200) {
          this.notifier.notify('success', res.responseDesc);
        } else {
          this.notifier.notify('danger', res.responseDesc);
        }
      }
    )
  }

  confiremBocking(id) {
    this.userService.confiremBooking(id).subscribe(
      res=>{
        if (res.responseCode === 200) {
          this.getAll(this.currentPage);
          this.modalRef.hide();
          this.notifier.notify('success', res.responseDesc);
        } else {
          this.notifier.notify('danger', res.responseDesc);
        }
      }
    )
  }

  cancelBooking(id) {
    this.userService.cancelBooking(id,this.resonForm.controls.reson.value,).subscribe(
      res=>{
        if (res.responseCode === 200) {
          this.getAll(this.currentPage);
          this.modalRef.hide();
          this.notifier.notify('success', res.responseDesc);
        } else {
          this.notifier.notify('danger', res.responseDesc);
        }
      }
    )
  }

  declineConfirem() {
    this.modalRef.hide();
  }

  confirmConfirem() {
    this.confiremBocking(this.requestId);
  }

  openModal(template,id) {
    this.requestId =id;
    this.modalRef = this.modalService.show(template, {class: 'modal-dialog-centered'});
  }

  declineCancel() {
    this.modalRef.hide();
  }

  confirmCancel() {
    this.cancelBooking(this.requestId)
  }

  search(pageIndex) {
    let req={
      clientEmail:this.searchForm.controls.email.value,
      clientName: this.searchForm.controls.client.value,
      mobileNumber: this.searchForm.controls.mobile.value,
    }
    let size = 10;
    let page = pageIndex - 1;
    this.userService.bookingsearch(size,page,req).subscribe(
      res=>{
        if (res.responseCode === 200) {
          this.bookings =res['data']['content'];
          this.page = res['data']['number'];
          this.totalRec = res['data']['totalElements'];
        } else {
          this.notifier.notify('danger', res.responseDesc);
        }
      }
    )

  }
}
